import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EIPDatePickerComponent } from 'eipdate-picker';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { CommonService } from 'src/app/Service/Common.service';
import { IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { finalDrawingList } from 'src/app/ViewModel/Tender-Quantity.Model';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { ICommunicationProtocol, ICommunicationInputModel } from 'src/app/ViewModel/CommunicationModel';
import { IProjectMasterViewModel } from 'src/app/ViewModel/ProjectMasterModel';
import { NotificationService } from 'src/app/Service/notification.service';

@Component({
  selector: 'app-Communication-Protocol',
  templateUrl: './Communication-Protocol.component.html',
  styleUrls: ['./Communication-Protocol.component.css']
})
export class CommunicationProtocolComponent implements OnInit {
  public projectId!: number;
  public projectCode!: string;
  public memberId!: number;
  public groupId!: number;
  public dynamicField: FieldConfig[] = [];
  public enableFilter = false;
  public from_Date: string|null = null;
  public to_Date: string|null = null;
  public stages: number |null= null;
  public drg_Type: string|null = null;
  public projectList: IProjectMasterViewModel[] = [];
  public fromDate: any;
  public ToMinDate!: Date;
  public projectElements: IProjectElementsOutput[] = [];
  public finalDrawingList: finalDrawingList[] = [];
  public CommunicationProtocolList: any[] = [];
  public ExternalCommunicationProtocolList: any[] = [];
  numElements: Map<string, string> = new Map<string, string>();
  public Project_Code!: string;
  public Trans_Type!: string;
  public GrdVisible = false;
  @ViewChild('todatePicker')
  dateRange!: EIPDatePickerComponent;
  
  constructor(
    private _commonService: CommonService, private dialog: MatDialog, private _notificationService: NotificationService, private CommunicationService: CommunicationService) { }

  ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.Project_Code = this._commonService.getProjectCode();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    //this.ComProtocalForm.get('ToggleControl').setValue("Internal");
    this.Trans_Type = "Internal";

  }

  finalView() {
    this.ExternalCommunicationProtocolList = [];
    this.CommunicationProtocolList = [];
    if (!this.projectId) {
      this._notificationService.showToast("Please select project", "Warning");
      return;
    }
    this.GrdVisible = false;
    let obj: ICommunicationInputModel = {} as ICommunicationInputModel;
    obj.Proj_Code = this.Project_Code;
    obj.Trans_Type = this.Trans_Type;
    obj.Project_Id = this.projectId;
    this.CommunicationService.GetCommunicationProtocol(obj).subscribe((data: ICommunicationProtocol[]) => {
      if (data && data.length > 0) {
        if (this.Trans_Type == 'External')
          this.ExternalCommunicationProtocolList = data;
        else
          this.CommunicationProtocolList = data;

        this.GrdVisible = true;
      }
      else { this._notificationService.showToast("No Records avilable.", "Warning"); }
    });
  }
  
  onToggleFormatChange(Value: string) {
    this.Trans_Type = Value
  }
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  addmembers(dataitem: ICommunicationProtocol) {
    dataitem.projectId = this.projectId;
    dataitem.groupId = this.groupId;
    this.CommunicationService.PostProjectCommunicationProtocol(dataitem).subscribe((res: any) => {

      if (res && res.successCode == 200) {

        this._notificationService.showToast(res.successMessage, "Success");
      }
      else
        this._notificationService.showToast(res.successMessage, "Warning");
    });
  }

}
